"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-six/sections/slideSection.tsx */

import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type SlideSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Certified Medical Professionals" | "Advanced Diagnostic Tools" | "Online Appointment Booking" | "Electronic Health Records" */
    h30Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
};
export type HomeSixSlideSectionGeneratedProps = {
    /** Default: "left" */
    divDataDirection?: string;
    /** Default: "slow" */
    divDataSpeed?: string;
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: SlideSectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
    slideSectionServicesSlides: SlideSectionServicesSlidesItem[];
    slideSectionServicesSlidesItemWrapper?: (item: SlideSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    slideSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    slideSectionServicesSlidesH3Visible?: boolean;
    slideSectionServicesSlidesH3Renderer?: (item: SlideSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    slideSectionServicesSlidesH3Props?: Partial<ComponentProps<"h3">> | ((item: SlideSectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
};

const HomeSixSlideSectionGenerated: FC<HomeSixSlideSectionGeneratedProps> = ({
    divDataDirection = "left",
    divDataSpeed = "slow",
    divH30H3Props,
    slideSectionServicesSlides,
    slideSectionServicesSlidesItemWrapper,
    slideSectionServicesSlidesRenderer,
    slideSectionServicesSlidesH3Visible,
    slideSectionServicesSlidesH3Renderer,
    slideSectionServicesSlidesH3Props,
}) => {
    return (
        <div className="horizontal-slide slide-one slide-six d-flex" data-direction={divDataDirection} data-speed={divDataSpeed}>
            <div className="slide-list d-flex gap-4">
                {renderCollectionNode(
                    slideSectionServicesSlides,
                    (item: SlideSectionServicesSlidesItem) => (
                        <div className={item.className ?? "services-slide"} key={item.key}>
                            {renderItemNode(slideSectionServicesSlidesH3Visible, slideSectionServicesSlidesH3Renderer, item, (
                                <h3 {...(typeof slideSectionServicesSlidesH3Props === "function" ? slideSectionServicesSlidesH3Props(item) : (slideSectionServicesSlidesH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>{item.h30Text}</h3>
                            ))}
                        </div>
                    ),
                    slideSectionServicesSlidesItemWrapper,
                    slideSectionServicesSlidesRenderer
                )}
            </div>
        </div>
    );
};

export default HomeSixSlideSectionGenerated;
